import { def, isNum } from 'lib/util'
import minLength from './minLength'

/**
 * Validator - Not Empty
 *
 * @param {T} value - value to validate
 * @param {Object} options - validator options
 * @returns {T} value - validated value
 */
export default (value, options) => (
  value !== null
  && def(value)
  && (value === true || isNum(value) || minLength(value, { ...options, min: 1 }))
    ? value
    : throw TypeError(options.error)
)
